<section *ngIf="company" class="mt-8">

  <div class="flex justify-between mb-8">
    <h2 class="text-xl font-semibold">Company information</h2>
  </div>

  <!-- Market share
  <div class="mb-8">
    <h3 class="text-md font-semibold mb-4">Market share</h3>
    <app-assistant-prompt tag="ASK_ASSISTANT_INITIAL_OUTREACH"
                          title="Personal interests"
                          [type]="'pills'"
                          [company]="company">
    </app-assistant-prompt>
  </div>
  -->

  <!-- Market insights
  <div class="relative blue-card h-36 p-3 mb-8">
    <app-assistant-prompt tag="ASK_ASSISTANT_BASIC_WORDS_IN_LOCAL_LANGUAGE"
                          title="Market insights"
                          [company]="company"
                          [showButton]="true"
                          [buttonType]="2"
                          [class]="'text-sm line-clamp-3'">
    </app-assistant-prompt>
  </div>
  -->

  <!-- Team areas of expertise
  <div>
    <h3 class="text-md font-semibold mb-4">Team areas of expertise</h3>
    <app-assistant-prompt tag="ASK_ASSISTANT_INITIAL_OUTREACH"
                          title="Personal interests"
                          [type]="'pills'"
                          [company]="company">
    </app-assistant-prompt>
  </div>
  -->

  <!--
  <div class="grid grid-cols-3 gap-6 mb-6">

    Revenue and profit
    <div class="col-span-2 border border-[#e7e6f3] rounded-lg p-6">
      <h3 class="text-base font-semibold uppercase pb-6">Revenue and profit</h3>
      // todo
    </div>

    Team size
    <div class="border border-[#e7e6f3] rounded-lg p-6">
      <h3 class="text-base font-semibold uppercase pb-4">Team size</h3>
      // todo
    </div>

  </div>
  -->

  <div *ngIf="company?.industry" class="mb-8">
    <h3  class="text-base font-semibold pb-3">Industry</h3>
    <div class="mb-6">
      <p class="!text-secondary dark:!text-primary-200">{{ company?.industry }}</p>
    </div>
  </div>

  <!-- Used technologies -->
  <div class="col-span-3 xl:col-span-1 mb-8">
    <h3 class="text-base font-semibold pb-6">Team areas of expertise</h3>

    <div *ngIf="company?.technologies.length > 0">
      <div *ngFor="let technology of company?.technologies;" class="pills">
            <span class="flex items-center text-xs text-secondary-900">
                {{ technology ?? ''}}
            </span>
      </div>
    </div>

    <div *ngIf="company?.technologies.length === 0">
      <p class="text-xs !text-gray-500">Used technoologies not found.</p>
    </div>

  </div>
  <!-- / Used technologies -->

  <div>
    <h3 class="text-md font-semibold mb-4">Top challenges</h3>
    <app-assistant-prompt tag="ASK_ASSISTANT_INDUSTRY_CHALLENGES"
                          title="Industry Challenges"
                          [type]="'insights'"
                          [company]="company"
                          [showButton]="true"
                          [buttonType]="1"
                          [reportId]="report?.id">
    </app-assistant-prompt>
  </div>

</section>
